<script>
    import { link } from "svelte-spa-router";

    export let service;
    export let route;

    let page = 1;
    let pageCount = 1;

    async function fetchData(page) {
        try {
            const responseData = await service.getPagedData(page);
            if (responseData) {
                pageCount = responseData.pageCount;
                return responseData;
            }
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function previous() {
        if (page > 1) {
            page--;
        }
    }

    function next() {
        if (page < pageCount) {
            page++;
        }
    }
</script>

<style>
    .menu {
        position: absolute;
        bottom: 10%;
    }
</style>

{#await fetchData(page)}
    <p>Loading...</p>
{:then data}
    <ol>
        {#each data.items as item}
            <li>
                <a href="{route}{item.id}" use:link>[{item.id}] {item.title}</a>
            </li>
        {/each}
    </ol>
{:catch error}
    <p style="color: red">{error.message}</p>
{/await}

<div class="menu">
    <button on:click={previous}>Previous</button>
    <span>{page} / {pageCount}</span>
    <button on:click={next}>Next</button>
</div>